const COURSE_STATUS_WORD: Record<string, string> = {
  draft: "Draft",
  published: "Published",
  archived: "Archived",
};

/** A course's publication state in words; a state this list does not know reads in sentence case. */
export function courseStatusWord(status: string): string {
  const known = COURSE_STATUS_WORD[status];
  if (known) return known;
  const words = status.replace(/_/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}
